export var TypeActionLandingPage;
(function (TypeActionLandingPage) {
    TypeActionLandingPage["Login"] = "LandingPage > Login";
    TypeActionLandingPage["Register"] = "LandingPage > Register";
    TypeActionLandingPage["Logout"] = "LandingPage > Logout";
    TypeActionLandingPage["LogoutConfirmation"] = "LandingPage > LogoutConfirmation";
})(TypeActionLandingPage || (TypeActionLandingPage = {}));
export var actionLandingPageLogin = function () { return ({
    type: TypeActionLandingPage.Login,
}); };
export var actionLandingPageRegister = function () { return ({
    type: TypeActionLandingPage.Register,
}); };
export var actionLandingPageLogout = function () { return ({
    type: TypeActionLandingPage.Logout,
}); };
export var actionLandingPageLogoutConfirmation = function () { return ({
    type: TypeActionLandingPage.LogoutConfirmation,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/landing-page/actionLandingPage.ts
// module id = 219
// module chunks = 3